import './scroll';

const handleHashParams = hash => new URLSearchParams(hash.replace(/^#\/?/, ''));

const handleClick = event => {
  const target = event.target;

  const clickedText =
    target.textContent ||
    target.innerText ||
    target.getAttribute('aria-label') ||
    null;

  if (clickedText) {
    UserTracker.emit('event', {
      eventName: 'global search conversion',
      data: {
        'clicked text': clickedText,
        request_path: window.location.pathname
      }
    });
  }
};

function handleJQueryEvents() {
  // Disabling old event listeners.
  window.odinListeners = [];
  document.addEventListener('turbolinks:before-visit', () => {
    window.odinListeners.forEach(listener => {
      let { el, args } = listener;
      $(el).off(...args);
    });
    window.odinListeners = [];
  });

  // Proxying jQuery .on to store all event listeners of jQuery.
  const _on = $.prototype.on;

  $.prototype.on = function () {
    let el = this.get(0);

    if (el && el !== document && el !== window) {
      window.odinListeners.push({ el, args: arguments });
    }

    return _on.call(this, ...arguments);
  };
}

(function () {
  'use strict';

  // Sending Is-Turbolinks-Request header in every Turbolinks calls.
  document.addEventListener('turbolinks:request-start', function (event) {
    window.isTurbolinksLoading = true;
    const xhr = event.data.xhr;
    xhr.setRequestHeader('Is-Turbolinks-Request', true);
  });

  document.addEventListener('turbolinks:load', function () {
    window.isTurbolinksLoading = false;

    const params = handleHashParams(window.location.hash);

    if (params.has('from_search') && params.get('from_search') !== '') {
      document.addEventListener('click', handleClick);
    }
  });

  window.document.addEventListener('turbolinks:before-visit', e => {
    const customUrls = [
      '/cursos',
      '/resumos',
      '/aulas',
      '/aulas/ao-vivo',
      '/playlist',
      '/video',
      '/simulados',
      '/'
    ];

    const current = e.data.url;
    const currentObject = new URL(current);
    // TODO: change 2 compare complex urls w/dynamic /:id and etc
    const urlPathName = '/' + currentObject.pathname.split('/')[1];

    const matchesUrls = customUrls.includes(urlPathName);

    if (matchesUrls) {
      e.preventDefault();
      window.location.assign(e.data.url);
    }

    document.removeEventListener('click', handleClick);
  });

  handleJQueryEvents();
  Turbolinks.start();
})();
